import { useTranslation } from 'react-i18next';
import type { PlayerScore } from '../../types/scoreboard';

interface ScoreTableProps {
  scores: PlayerScore[];
}

export function ScoreTable({ scores }: ScoreTableProps) {
  const { t } = useTranslation('scoreboard');

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-gray-700">
            <th className="text-left py-3 px-4 text-gray-400 font-medium">#</th>
            <th className="text-left py-3 px-4 text-gray-400 font-medium">{t('table.player')}</th>
            <th className="text-right py-3 px-4 text-gray-400 font-medium">{t('table.points')}</th>
            <th className="text-right py-3 px-4 text-gray-400 font-medium">{t('table.games')}</th>
            <th className="text-right py-3 px-4 text-gray-400 font-medium">{t('table.wins')}</th>
          </tr>
        </thead>
        <tbody>
          {scores.map((player, idx) => (
            <tr
              key={player.userId}
              className={`border-b border-gray-800 hover:bg-mafia-card/50 transition-colors ${
                idx === 0 ? 'text-mafia-gold' : idx === 1 ? 'text-gray-300' : idx === 2 ? 'text-amber-600' : ''
              }`}
            >
              <td className="py-3 px-4 font-bold">{idx + 1}</td>
              <td className="py-3 px-4 font-medium">
                {player.currentDisplayName ?? player.displayName}
                {player.currentDisplayName && (
                  <span className="ml-2 text-xs text-mafia-muted font-mono font-normal">
                    (aka {player.displayName})
                  </span>
                )}
              </td>
              <td className="py-3 px-4 text-right font-bold">{player.points}</td>
              <td className="py-3 px-4 text-right text-gray-400">{player.gamesPlayed}</td>
              <td className="py-3 px-4 text-right text-gray-400">{player.wins}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
